<template>
  <div id="app">

    <PageHeader
      :siteName="siteName"
      :navLinks="navLinks">
    </PageHeader>

    <a class="skipLink" href="#main">
      Skip to main content
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16">
        <path d="M277.375 85v259.704l119.702-119.702L427 256 256 427 85 256l29.924-29.922 119.701 118.626V85h42.75z"/>
      </svg>
    </a>

    <transition name="woosh" mode="out-in">
      <router-view></router-view>
    </transition>

    <PageFooter
      :siteName="siteName"
      :footerLinks="footerLinks">
    </PageFooter>

  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'

export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter
  },
  data () {
    return {
      siteName: 'Nathan Lecompte',
      navLinks: [
        { name: 'About', url: '/' },
        { name: 'Contact', url: '/contact' },
        { name: 'Work', url: '/work' }
      ],
      footerLinks: [
        { name: 'Credits', url: '/credits' },
        { name: 'Privacy', url: '/privacy' },
        { name: 'Sitemap', url: '/sitemap' }
      ]
    }
  }
}
</script>

<style>
/* Global Fonts */
@font-face {
  font-family: 'Mada';
  src: local('Mada'),
       local('Mada-Regular'),
       url('/res/fonts/mada.woff2') format('woff2'),
       url('/res/fonts/mada.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'Mada';
  src: local('Mada SemiBold'),
       local('Mada-SemiBold'),
       url('/res/fonts/mada-semibold.woff2') format('woff2'),
       url('/res/fonts/mada-semibold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}
@font-face {
  font-family: 'Assistant';
  src: local('Assistant Bold'),
       local('Assistant-Bold'),
       url('/res/fonts/assistant-bold.woff2') format('woff2'),
       url('/res/fonts/assistant-bold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  unicode-range: U+000-5FF;
}

/* Global Variables */
:root {
  --bCol: 255, 255, 255;
  --tCol1: 0, 0, 0;
  --tCol2: 90, 90, 90;
  --acc: 0, 0, 0;
  --fnt1: 'Mada', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
  --fnt2: 'Assistant', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
}
@media (prefers-color-scheme: dark) {
  :root {
    --bCol: 20, 20, 20;
    --tCol1: 255, 255, 255;
    --tCol2: 190, 190, 190;
    --acc1: 255, 255, 255;
  }
}

/* Global Selection Style */
::selection {
  background-color: rgb(var(--acc1));
  color: rgb(var(--bCol));
}
::-moz-selection {
  background-color: rgb(var(--acc1));
  color: rgb(var(--bCol));
}

/* Global Transitions */
.woosh-enter-active,
.woosh-leave-active {
  transition: .2s ease
}
.woosh-enter {
  opacity: 0;
}
.woosh-leave-to {
  opacity: 0;
  transform: scale(.98)
}

/* Global Page Layout */
body {
  background: rgb(var(--bCol));
  margin: 0;
}
</style>
